<div class="all_info--stat-lesson-info">
  <div class="class_title--stat-lesson-info">
    <span *ngIf="student_class">{{ student_class.title }}&nbsp;<span class="span_no_bold--stat-lesson-info">класс</span></span>
  </div>
  <div class="common_info--stat-lesson-info">
    <span class="subject_name--stat-lesson-info" *ngIf="subject">
      {{ subject.title }}
    </span>
    <img src="/assets/images/statistics/divider_lesson_stat.png" class="divider_icon--stat-lesson-info">
    <a
      class="lesson_title--stat-lesson-info"
      *ngIf="lesson"
      [routerLink]="['/teacher', 'prepare', lesson.id, 'edit']">
      Занятие № <span>{{ lesson.full_lesson_number }}</span>
    </a>
    <img src="/assets/images/statistics/divider_lesson_stat.png" class="divider_icon--stat-lesson-info">
    <span class="lesson_title--stat-lesson-info date--stat-lesson-info" *ngIf="lesson">
      {{ lesson.date|date:"dd.MM.yyyy" }}&nbsp;г.
    </span>
  </div>
  <div class="blank--stat-lesson-info">
  </div>
</div>
